let layeredSlideshowPromise;

function loadLayeredSlideshow() {
  if (!layeredSlideshowPromise) {
    layeredSlideshowPromise = import(new URL('layered-slideshow-core.js', import.meta.url).href);
  }

  return layeredSlideshowPromise;
}

function loadIfLayeredSlideshowExists() {
  if (document.querySelector('layered-slideshow-component')) loadLayeredSlideshow();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', loadIfLayeredSlideshowExists, { once: true });
} else {
  loadIfLayeredSlideshowExists();
}
